import { z } from 'zod';

import { ESTADOS_PROYECTO, type CrearProyectoInput } from '@/entities/proyecto';
import { finMayorOIgualInicio, ISO_DATE_RE } from '@/shared/lib';

const fkSelectable = z
  .number({ message: 'Seleccione un valor.' })
  .int()
  .min(1, 'Seleccione un valor.');

export const pasoDatosGeneralesSchema = z
  .object({
    nombre: z
      .string()
      .trim()
      .min(1, 'El nombre es obligatorio.')
      .max(200, 'Máximo 200 caracteres.'),
    // Siglas del código oficial de incidencias (RI-SUP-<SIGLAS>-<N>-<YYYY>).
    // Opcionales: vacías ⇒ el backend usa el fallback `P<id>`. Se guardan en
    // MAYÚSCULAS; el backend valida unicidad (409 PROYECTO_SIGLAS_DUPLICADAS).
    siglas: z
      .string()
      .trim()
      .toUpperCase()
      .regex(/^[A-Z0-9]{2,10}$/, 'Solo letras y números, de 2 a 10 caracteres.')
      .or(z.literal(''))
      .optional(),
    descripcion: z.string().trim().max(1000, 'Máximo 1000 caracteres.').optional(),
    estado: z.enum(ESTADOS_PROYECTO),
    fechaInicio: z.string().regex(ISO_DATE_RE, 'Fecha requerida.'),
    fechaFinEstimada: z.string().regex(ISO_DATE_RE, 'Fecha requerida.'),
    origenProyectoId: fkSelectable,
    naturalezaFinancieraId: fkSelectable,
    tipoInfraestructuraId: fkSelectable,
    tipoServicioId: fkSelectable,
  })
  .refine(...finMayorOIgualInicio('Debe ser igual o posterior a la fecha de inicio.'));

export type PasoDatosGeneralesValues = z.infer<typeof pasoDatosGeneralesSchema>;

export function asCrearProyectoInputPartial(
  values: PasoDatosGeneralesValues,
): Partial<CrearProyectoInput> {
  const descripcion = values.descripcion?.trim();
  const siglas = values.siglas?.trim().toUpperCase();
  return {
    nombre: values.nombre,
    ...(siglas ? { siglas } : {}),
    ...(descripcion ? { descripcion } : {}),
    estado: values.estado,
    fechaInicio: values.fechaInicio,
    fechaFinEstimada: values.fechaFinEstimada,
    origenProyectoId: values.origenProyectoId,
    naturalezaFinancieraId: values.naturalezaFinancieraId,
    tipoInfraestructuraId: values.tipoInfraestructuraId,
    tipoServicioId: values.tipoServicioId,
  };
}
